var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-history-entry"},[_c('div',{staticClass:"filter-history-entry__item",on:{"click":function($event){return _vm.onClick(_vm.history.filterCondition)}}},[_c('div',{staticClass:"filter-history-entry__item-elapsed"},[_vm._v(_vm._s(_vm.elapsed(_vm.history)))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }